import React from 'react'

import { connect } from 'react-redux'

import Row from "./row";
import AddRow from "./addRow";

import {selectRow} from "../../actions/index";

const Body = ({ body, row, handleRowSelection }) => (
    <div style={{border: "dashed 1px lightgray", padding: "5px"}}>
        <span style={{textDecoration: "underline"}}>Body</span>
        {body.map((content, index) => (
        <div key={index}>
            <Row 
                content={content} 
                id={content.id} 
                selected={row.selected === content.id}
                onSelection={handleRowSelection}
                parentIndex={index}
                sectionName="body"
            />
        </div>
        ))}
        <AddRow list={body} 
            lastRowId={body.length > 0 ? body[body.length - 1].id : 'design_body_1'}
        />
    </div>
);

const mapStateToProps = (state) => {
    return { 
        body: state.design.body,
        row: state.row
    }
}

const mapDispatchToProps = dispatch => {
    return {
        handleRowSelection: id => {
            dispatch(selectRow(id))
        }
    }
  }

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Body)